import Section3 from "../../Data/TermsContent";
const TermsAndConditions = () => {
  return (
    <div className="px-[20px] lg:px-[100px]">
      <div>
        <h1 className="pt-8 lg:pt-12 text-center text-level-2 lg:text-level-1 font-nonito_sans text-primary-text font-bold">
          Terms & Conditions
        </h1>
      </div>
      <div className="mt-6 lg:mt-[40px] mb-14 lg:mb-[88px] w-full bg-white border-[#CBD5E0] border-[1px] rounded-[20px] p-6">
        <div className="text-base leading-6 text-justify text-content">
          {/* Section 1 */}
          <p className="mb-8">
            This General Terms of Service Agreement (the “Agreement”) is a legal agreement made and entered into as of the date of your affirmative acceptance of this Agreement (the “Effective Date”) by and between You and Jumaconnect Limited, a private company in Ghana (registration number CS-002110125) with its principal place of business located at No. 8, Nii Kodua Road, Adenta – Accra, Ghana. (“Jumaconnect”).
          </p>
          <p className="mb-8">
            This Agreement shall govern your use of Jumaconnect’s services, including websites, software, and other products and services (collectively, the “Services”) and the legal entity on whose behalf you are registering a Jumaconnect account (the “Business”).
          </p>
        </div>
        <div className="text-base leading-6 text-justify">


        {/* Section 2: Numbered List and Bolded Titles */}
<ol className="list-decimal pl-6 space-y-8 font-inter font-normal text-base leading-6 tracking-normal text-justify text-content">
  <li>
    <strong>Facilitating Connections: </strong> Jumaconnect is an innovative online platform designed to connect clients—individuals or businesses seeking job completion—with service providers, who are independent contractors offering job-related services using their own tools and supplies.
  </li>
  <li>
    <strong>Service Accessibility: </strong> The platform enables clients to search for service providers and post job requests, ensuring a seamless matchmaking process for various service needs.
  </li>
  <li>
    <strong>Job Discovery for Service Providers: </strong> Service providers can browse and apply for jobs posted by clients, creating opportunities for independent professionals to find work efficiently.
  </li>
  <li>
    <strong>Direct Communication: </strong> Clients have the ability to contact service providers of their choice based on ratings, reviews, and other criteria, and can communicate with them directly through the platform’s integrated chat feature.
  </li>
  <li>
    <strong>Service Provider Engagement: </strong> Service providers can also initiate contact with clients who have posted jobs, fostering a dynamic and interactive service marketplace.
  </li>
  <li>
    <strong>Negotiation and Agreement: </strong> Both clients and service providers have the freedom to negotiate pricing and job details. The service provider then creates an offer within the platform, which the client may accept or decline.
  </li>
  <li>
    <strong>Secure Payment System: </strong> Once an offer is accepted, the client makes payment covering both the service provider’s fee and Jumaconnect’s platform charges. Funds are securely held until the job is completed and the client confirms satisfaction, after which the service provider receives payment minus the platform fee.
  </li>
  <li>
    <strong>Job Completion and Dispute Resolution: </strong> Clients are notified upon job completion and have five (5) days to confirm satisfaction or raise a dispute. If no action is taken within this period, the job is automatically marked as complete, and payment is released to the service provider.
  </li>
  <li>
    <strong>Platform Integrity and Communication: </strong> To ensure transparency and accountability, all job-related communication must take place within the Jumaconnect platform. Jumaconnect is not liable for any discussions or agreements made outside the platform.
  </li>
  <li>
    <strong>Identity Verification: </strong> The platform ensures the identity verification of service providers through a third-party verification system, enhancing trust and security.
  </li>
  <li>
    <strong>User Reviews and Feedback: </strong> Both clients and service providers are encouraged to leave reviews and feedback on completed jobs to maintain a transparent and reputable service marketplace.
  </li>
  <li>
    <strong>No Skill or License Verification: </strong> While Jumaconnect verifies the identities of service providers, it does not undertake independent investigations into their skills, qualifications, or professional licenses. Clients are advised to exercise due diligence when selecting service providers.
  </li>
</ol>


        {/* Section 3: Imported from Section3.js */}
        <Section3 />
        </div>


      </div>
    </div>
  );
};

export default TermsAndConditions;
